import SolicitacaoBolsaAtividades from './componentes/SolicitacaoBolsaAtividades.vue';
import SolicitacaoBolsaAtividadesLista from './componentes/SolicitacaoBolsaAtividadesLista.vue';
import SolicitacaoBolsaAtividadesForm from './componentes/SolicitacaoBolsaAtividadesForm.vue';

export default {
  path: '/solicitacao-bolsa-atividades',
  component: SolicitacaoBolsaAtividades,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoBolsaAtividadesLista,
      name: 'solicitacao-bolsa-atividades',
    },
    {
      path: ':idCript',
      component: SolicitacaoBolsaAtividadesForm,
      name: 'solicitacao-bolsa-atividades.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-bolsa-atividades/rotas.js